import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { 
  persistStore, 
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import chatReducer from '@/features/chat/chatSlice';
import canvasReducer from '@/features/canvas/canvasSlice';
import authReducer from '@/features/auth/authSlice';
import orderReducer from '@/features/order/orderSlice';
import serviceReducer from '@/features/service/serviceSlice';
import supervisorReducer from '@/features/supervisor/supervisorSlice';
import preferencesReducer from '@/features/preferences/preferencesSlice';
import referenceReducer from '@/features/reference/referenceSlice';
import walletReducer from '@/features/wallet/walletSlice';

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  whitelist: ['chat', 'canvas', 'order', 'auth', 'service', 'supervisor', 'preferences', 'wallet', 'reference'],
};

const appReducer = combineReducers({
  chat: chatReducer,
  canvas: canvasReducer,
  auth: authReducer,
  order: orderReducer,
  service: serviceReducer,
  supervisor: supervisorReducer,
  preferences: preferencesReducer,
  wallet: walletReducer,
  reference: referenceReducer,
});

const persistedReducer = persistReducer(persistConfig, appReducer);

const isProduction = typeof import.meta !== 'undefined' && import.meta.env?.MODE === 'production';

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
  devTools: !isProduction,
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;


